import not from "../images/404.png";

export default function NotFound() {
  return <img src={not} alt="page not found"></img>;
}
